import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  IconPhone,
  IconPlugConnected,
  IconCalendarEvent,
  IconUsers,
  IconClock,
  IconMailForward,
} from '@tabler/icons-react';
import KpiCard from './KpiCard';
import KpiCardSkeleton from './KpiCardSkeleton';
import type { DashboardOverviewKpis } from '@types';

interface KpiStripProps {
  kpis: DashboardOverviewKpis | null;
  isLoading: boolean;
  prevPeriod: { from: Date; to: Date } | null;
}

const KPI_CONFIG = [
  { key: 'totalCalls' as const, i18nKey: 'dashboard.overview.kpi.totalCalls', icon: <IconPhone size={18} />, formatType: 'number' as const },
  { key: 'connectRate' as const, i18nKey: 'dashboard.overview.kpi.connectRate', icon: <IconPlugConnected size={18} />, formatType: 'percent' as const },
  { key: 'appointmentsSet' as const, i18nKey: 'dashboard.overview.kpi.appointments', icon: <IconCalendarEvent size={18} />, formatType: 'number' as const },
  { key: 'activeSessions' as const, i18nKey: 'dashboard.overview.kpi.activeSessions', icon: <IconUsers size={18} />, formatType: 'number' as const },
  { key: 'avgCallDuration' as const, i18nKey: 'dashboard.overview.kpi.avgDuration', icon: <IconClock size={18} />, formatType: 'duration' as const },
  { key: 'voicemailRate' as const, i18nKey: 'dashboard.overview.kpi.voicemailRate', icon: <IconMailForward size={18} />, formatType: 'percent' as const },
] as const;

export default function KpiStrip ({ kpis, isLoading, prevPeriod }: KpiStripProps): React.JSX.Element {
  const { t } = useTranslation();

  if (isLoading || kpis === null) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <KpiCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
      {KPI_CONFIG.map(({ key, i18nKey, icon, formatType }) => (
        <KpiCard
          key={key}
          label={t(i18nKey)}
          icon={icon}
          kpiValue={kpis[key]}
          formatType={formatType}
          prevPeriod={prevPeriod}
          isLive={key === 'activeSessions'}
        />
      ))}
    </div>
  );
}
